import { useTranslation } from 'react-i18next'

import { useModalStore } from '@features/modal'

import SlotsModal from '@widgets/slots/ui/modal/modal'
import styles from '@widgets/slots/ui/modal/styles.module.scss'



export default function useSlots () {
  const { t: tc } = useTranslation('common')
  const { openModal, closeModal } = useModalStore()

  const openSlotsModal = () => {
    openModal('slots', <SlotsModal />, {
      title: tc('slots.title'),
      description: tc('slots.description'),
      classes: {
        body: styles['modal-body'],
        content: styles['modal-content'],
      },
    })
  }

  const closeSlotsModal = () => {
    closeModal('slots')
  }

  return {
    openSlotsModal,
    closeSlotsModal,
  }
}
